
/*========================================================================
 * $Id: getprofile.js 76458 2013-11-12 09:34:35Z jakob.praher $
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

Mindbreeze.define('api/v2/getprofile',[
    "i18n/i18n",
    "api/v2/common",
    "backbone",
    "underscore",
    "model/readonlytree",
    "service/stub",
    "service/factory",
    "utils/clone"
  ], function(
    i18n,
    Common,
    Backbone,
    _,
    ReadOnlyTreeModel,
    Stub,
    ServiceFactory,
    clone
  ) {
  var GetProfile = {};

  var GetProfileServiceStub = GetProfile.GetProfileServiceStub = Stub.extend({
    path: "getprofile",

    call: function(channel, request, responseObserver) {
      return Stub.prototype.call.apply(this, [channel, request, responseObserver]);
    }
  });
  
  var GetProfileOutputModel = GetProfile.GetProfileOutputModel = ReadOnlyTreeModel.extend({

    initialize: function (options) {
      this.channel = options.channel;
      this.serviceStub = options.serviceStub;
    },

    parse: function (response) {      
      response = _.clone(response);
      response.status_messages = Common.StatusMessages.parse(response.status_messages);
      return response;
    },

    merge: function (merged, rhs, options) {
      return merged;
    },

    update: function (channel, callback) {
      var that = this,
          responseObserver = this._responseObserver = {},
          request = {};

      if (!channel) {
        this.load({
        });
      }

      _.extend(responseObserver, Backbone.Events);
      this._responseObserver.on("response", function (response) {
        that.load(response, {parse: true, merge: false});
        if (_.isFunction(callback)) {
          callback(that);
        }
      });
      if (_.isFunction(callback)) {
        this._responseObserver.on("error", function (error) {
          try {
            callback(null, error);
          } catch (e) {
            if (console && console.error) console.error(e, e.stack);
          }
        });
      }

      this.serviceStub.cast(channel || this.channel, request, responseObserver);
    }
  });
  
  var GetProfileServiceFactory = GetProfile.ServiceFactory = function() {}
  
  _.extend(GetProfileServiceFactory.prototype, ServiceFactory.prototype, {
      /*    createInput:  function(attrs,options) { return new GetProfileInputModel(attrs, options); },*/
    createModel:  function(channel, options) {
      options = options || {};
      options.channel = options.channel || channel;
      options.serviceStub = options.serviceStub || new GetProfileServiceStub();
      var model = new GetProfileOutputModel({}, options);
      return model;
    }
  });

  return GetProfile;
})
;